import store from '../vuex/store.js';
import wx from 'weixin-js-sdk';
import apis from '../request/apis.js';
import { Toast, Dialog } from 'vant';
import dayjs from 'dayjs';

const TokenKey = 'BIGGIF-TOKEN';
const UserInfoKey = 'BIGGIF-USERINFO';
const ProjectKey = 'BIGGIF-PROJECT';

export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function clearStorage() {
  return localStorage.clear();
}

export const getUserInfoStorage = () => {
  let userInfos = localStorage.getItem(UserInfoKey);
  if (userInfos && (userInfos != undefined || userInfos != null)) return JSON.parse(userInfos);
  else return {};
};

export const getProjectData = () => {
  let project = localStorage.getItem(ProjectKey);
  if (project == 'undefined' || project == 'null') return { hisId: '', resourceType: '' };
  else return JSON.parse(project);
};

//页面初始化获取页面参数
export async function paramsInit(toast = true) {
  return new Promise(async (resolve, reject) => {
    try {
      let wxobj = {
        // projectInfos:
        //   '%7B%22project%22%3A%7B%22hisId%22%3A30593,%22resourceType%22%3A6%7D,%22token%22%3A%22eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjQ4OCwib3BlbklkIjoibzJVYnM2Mk1LMTFOTmlQbW8tZS1IMWlsem5iayIsImlhdCI6MTc3MzkwODQ5MSwiZXhwIjo2MTc3MzkwODQ5MSwibmJmIjoxNzczOTA4NDkxfQ.Lss3CT_ztcoA8X0GaZfZ4wyRMllaS-ULQdwpLKgxUo0%22,%22groupID%22%3A476,%22liveUrl%22%3A%22webrtc%3A%2F%2Fhls.jinbaniu.com%2Flive%2F30593%22%7D',
        // time: '1773977022007',
        // 'stack-key': '5013ab54'
      };
      window.location.href.replace(/([^?&=]+)=([^&]+)/g, (_, k, v) => (wxobj[k] = v));

      const decodedStr = decodeURIComponent(wxobj.projectInfos);
      const jsonObject = JSON.parse(decodedStr);

      console.log(wxobj, '我是页面参数======');
      console.log(jsonObject);

      // 设置项目信息id
      store.commit('setProject', jsonObject.project);

      // 设置token，只有从小程序直播列表点击进入才有token
      if (jsonObject.hasOwnProperty('token') && jsonObject.token) {
        store.commit('setToken', jsonObject.token);
      }

      // 检测token
      await checkToken(store.state.token);

      // 获取用户信息
      await store.dispatch('getUserInfo');

      // 获取项目信息
      store.dispatch('getProjectInfo', jsonObject.project);

      resolve(jsonObject);
    } catch (error) {
      console.error(error);
      Toast(error.message || '信息获取失败');
      reject(error.data);
    }
  });
}

//跳转回小程序并传参
export function jumpToMini(type, path, params = null) {
  console.log(wx);
  wx.miniProgram[type]({ url: path });
  wx.miniProgram.postMessage({
    data: { params: params, info: '我是参数' }
  });
}

/**
 * @description: 筛选功能确认数据处理
 * @params Obj
 */
export function filterSelectedIds(data) {
  const result = {};
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      result[key] = data[key].filter(item => item.select).map(item => item.id);
    }
  }
  return result;
}

/**
 * @description: 数据排序
 * @params Obj
 */
export function arrSort(arr) {
  let sortedArr = [];
  if (arr.length) {
    sortedArr = arr.sort((a, b) => {
      const numA = parseInt(a, 10);
      const numB = parseInt(b, 10);
      if (numA !== numB) {
        return numA - numB;
      }
      const strA = a.slice(numA.toString().length);
      const strB = b.slice(numB.toString().length);
      return strA.localeCompare(strB);
    });
  }
  return sortedArr;
}

/**
 * @description: 获取当前项目活动列表，返回指定类型活动
 * @params value 1-活动 2-带看 3-定金
 * @returns Promise
 */
export async function getActivityInfo(value, key = 'wxActiviId') {
  return new Promise(async (resolve, reject) => {
    try {
      let takeFind = {};
      const res = await apis.getActivityListApi(store.state.project.hisId, store.state.userInfo.uid ? store.state.userInfo.uid : '');
      if (res.code == '000000') {
        takeFind = res.data.find(item => item[key] == value);
      }
      resolve(takeFind);
    } catch (error) {
      reject(error);
    }
  });
}

export function getSystem() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //Android
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
  return { Android: isAndroid, iOS: isiOS };
}

/**
 * @description: token校验
 * @params token
 */
async function checkToken(token) {
  if (!token) return;

  let Base64 = require('js-base64').Base64;
  let tokenData = token;
  let tangdaye = JSON.parse(Base64.decode(tokenData.split('.')[1]));

  let endTime = new Date(tangdaye.exp * 1000);

  // 判断时间是否过期
  if (new Date() > endTime) {
    console.log('token已过期');

    store.commit('removeUserInfo');
    store.commit('removeToken');
  }
}

function formatDate(date) {
  const year = date.getFullYear(); // 获取年份，4位数
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份，0-11，需要+1，补齐两位
  const day = String(date.getDate()).padStart(2, '0'); // 日期，补齐两位
  const hours = String(date.getHours()).padStart(2, '0'); // 小时，补齐两位
  const minutes = String(date.getMinutes()).padStart(2, '0'); // 分钟，补齐两位
  const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒，补齐两位

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * @description: 计算时间差
 * @params end 结束事件
 * @returns number 毫秒
 */
export function getCountTime(end) {
  let currentDate = dayjs();

  let endTime = end ? dayjs(end) : dayjs();

  let timeDifference = endTime.diff(currentDate);

  return Number(timeDifference);
}



// WEBPACK FOOTER //
// ./src/utils/index.js